import * as i0 from '@angular/core';
import { input, effect, Directive } from '@angular/core';
let EditableDirective = /*#__PURE__*/(() => {
  class EditableDirective {
    constructor(elementRef) {
      this.elementRef = elementRef;
      this.futEditable = input();
      effect(() => {
        const label = this.futEditable();
        if (!label) {
          return;
        }
        this.elementRef.nativeElement.setAttribute('_futura-editable', label);
      });
    }
    static {
      this.ɵfac = function EditableDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EditableDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: EditableDirective,
        selectors: [["", "futEditable", ""]],
        inputs: {
          futEditable: [1, "futEditable"]
        },
        standalone: true
      });
    }
  }
  return EditableDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { EditableDirective };
